import { Component, Inject, OnInit, ViewChild, inject } from '@angular/core';
import { NgIf, NgStyle, NgClass } from '@angular/common';

import { AnagraficaComponent } from '../components/anagrafica/anagrafica.component';
import { ParteAComponent } from '../components/parte-a/parte-a.component';
import { ParteBComponent } from '../components/parte-b/parte-b.component';
import { Router, RouterLink } from "@angular/router";
import { SharedFormService } from '../services/shared-form.service';
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { RandomDataService } from '../services/random-data.service';
import { ApiService } from '../services/api.service';
import { firstValueFrom } from "rxjs";
import { AnagraficaPage, Comune, Stato } from '../model/model';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '../services/toast.service';
import { FormGroup } from '@angular/forms';
import { AssignComuniService } from '../services/assign-comuni.service';
import { AssignStatiService } from '../services/assign-stati.service';
import { InserisciSchedaService } from '../services/inserisci-scheda.service';
import { SwitchModalitaService } from '../services/switch-modalita.service';
import { Subject, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-scheda-morte',
  standalone: true,
  imports: [NgIf, NgStyle, NgClass, AnagraficaComponent, ParteAComponent, ParteBComponent, RouterLink],
  templateUrl: './scheda-morte.component.html',
  styleUrls: ['./scheda-morte.component.scss']
})
export class SchedaMorteComponent implements OnInit {
  isParteA: boolean = true;
  isParteB: boolean = false;
  @BlockUI() blockUI!: NgBlockUI;
  form = this.sharedFormService.form;
  route = inject(ActivatedRoute);
  @ViewChild(AnagraficaComponent) anagraficaComponent: AnagraficaComponent | undefined;
  @ViewChild(ParteAComponent) parteAComponent: ParteAComponent | undefined;
  @ViewChild(ParteBComponent) parteBComponent: ParteBComponent | undefined;
  public modalita: boolean = false;
  modificaModalita = new Subject<boolean>();
  public attivaBordi: boolean = false;
  attivaModal: boolean = false;
  public giaInModifica: boolean = false;
  public modificaSubject = new Subject<boolean>();



  pagina: number = 0;
  righeXPagina: number = 10;
  sortBy: string = "id";
  sortDirection: string = "DESC";
  //paginaAnagrafica: AnagraficaPage | undefined;

  utente!: any;

  modificaAbilitata: boolean = false;
  schedaInviata: boolean = false;

  public id: string|undefined;

  async annulla() {
    this.router.navigate(['ricerca-schede']);
    this.modalita = false;
    // this.switchModalita.giaModificaA = false;
    // this.switchModalita.giaModificaB = false;
  }


  async goToParteA() {
    this.isParteA = true;
    this.isParteB = false;
  }

  async goToAnagrafica() {
    this.isParteA = false;
    this.isParteB = false;
  }

  async goToParteB() {
    this.isParteA = false;
    this.isParteB = true;
  }

  constructor(private sharedFormService: SharedFormService, private rds: RandomDataService, private api: ApiService,
    public toastService: ToastService, private router: Router, private assignComuni: AssignComuniService,
    private assignStati: AssignStatiService, private inserisciScheda: InserisciSchedaService,
    private switchModalita: SwitchModalitaService) {
  }
  dataLoaded = false;
  async ngOnInit() {

    this.dataLoaded = false;
    this.modalita = false;
    this.giaInModifica = false;
    this.id = this.route.snapshot.params['id'];
    
    if (this.id != undefined) {
      this.modalita = false;
      this.modificaSubject.next(false);
    }
    else {
      this.modalita = true;
      this.modificaAbilitata = true;
      this.schedaInviata = false;
    }

    this.assignComuni.comuni = await firstValueFrom(this.api.getComuni());
    this.assignComuni.comuni.forEach((comune: Comune) => {
      comune.descrComune = comune.descrComune?.trim();
    });

    this.assignStati.stati = await firstValueFrom(this.api.getStati());
    this.assignStati.stati.forEach((stato: Stato) => {
      stato.descrizione = stato.descrizione?.trim();
    });

    this.dataLoaded = false;
    this.id = this.route.snapshot.params['id'];
    if (this.id !== undefined) {
      this.blockUI.start("Caricamento dati della scheda in corso");
      const ana = await firstValueFrom(this.api.getAnagrafica(parseInt(this.id))).finally(this.blockUI.stop);
      this.caricaDati(ana);
    } else {
      this.clearDati();
    }
    this.dataLoaded = true;    

  }

  setModifica() {
    this.modalita = true;
    this.giaInModifica = true;
    this.modificaSubject.next(true);
  }

  //async loadTableData() {
  //  this.blockUI.start("Caricamento dati in corso");
  //  this.paginaAnagrafica = await firstValueFrom(this.api.getAnagrafichePaginate(this.pagina, this.righeXPagina, this.sortBy, this.sortDirection)).finally(() => this.blockUI.stop());
  //}

  async ngAfterViewInit() {

  }

  caricaDati(data: any) {

    let utenteString = sessionStorage.getItem("utente");
    if(utenteString != null){
      let utente = JSON.parse(utenteString);
      if(utente?.nomeRuolo.includes("operatore-regione") || utente?.nomeRuolo.includes("operatore-struttura")) {
        this.modificaAbilitata = false;
      }
      else if(utente?.nomeRuolo.includes("operatore-asl") && data.fkIdFlusso == null) {
        this.modificaAbilitata = true;
        this.schedaInviata = false;
      }
      if(data.fkIdFlusso != null) {
        this.schedaInviata = true;
      }
    }
    
    this.form.get('anagraficaForm')?.patchValue(data);
    //parte A
    this.form.get('parteA')?.patchValue(data.datiParteAS);
    this.form.get('parteA')?.get('territorioDecesso')?.patchValue(data.datiParteAS);
    //comune decesso
    let codComune = data.datiParteAS.fkComuneDecesso;
    if (codComune != null) {
      const selectedComune = this.assignComuni.comuni.find((comune: Comune) => comune.codComune?.trim() === codComune.trim());
      this.form.get('parteA')?.get('territorioDecesso')?.get('fkComuneDecessoDescr')?.patchValue(selectedComune?.descrComune);
    }
    //
    this.form.get('parteA')?.get('causaMortePatologia')?.patchValue(data.datiParteAS);
    this.form.get('parteA')?.get('causaMorteCondizioni')?.get('condizione1')?.patchValue(data.datiParteAS);
    this.form.get('parteA')?.get('causaMorteCondizioni')?.get('condizione2')?.patchValue(data.datiParteAS);
    this.form.get('parteA')?.get('causaMorteCondizioni')?.get('condizione3')?.patchValue(data.datiParteAS);
    this.form.get('parteA')?.get('causaMorteCondizioni')?.get('condizione4')?.patchValue(data.datiParteAS);
    this.form.get('parteA')?.get('altriStatiMorbosi')?.get('stato1')?.patchValue(data.datiParteAS);
    this.form.get('parteA')?.get('altriStatiMorbosi')?.get('stato2')?.patchValue(data.datiParteAS);
    this.form.get('parteA')?.get('altriStatiMorbosi')?.get('stato3')?.patchValue(data.datiParteAS);
    this.form.get('parteA')?.get('incidenteTrasporti')?.patchValue(data.datiParteAS);
    this.form.get('parteA')?.get('dichiarazioni')?.patchValue(data.datiParteAS);
    //data8
    const giorno8 = parseInt(data.datiParteAS.giornoEvento, 10);
    const mese8 = parseInt(data.datiParteAS.meseEvento, 10);
    const anno8 = parseInt(data.datiParteAS.annoEvento, 10);
    this.form.get('parteA')?.get('dataEvento')?.patchValue({
      orarioEventoHh: data.datiParteAS.orarioEventoHh,
      orarioEventoMm: data.datiParteAS.orarioEventoMm,
      data8selected: {
        "year": anno8,
        "month": mese8,
        "day": giorno8
      }
    })
    //data dichiarazioni
    //const dataDichiarazioniParteAS = data.datiParteAS.dataCompilazione.split('-');
    const dataDichiarazioniParteAS = data.datiParteAS.dataCompilazione;
    const giornoDichiarazioni = parseInt(dataDichiarazioniParteAS[2], 10);
    const meseDichiarazioni = parseInt(dataDichiarazioniParteAS[1], 10);
    const annoDichiarazioni = parseInt(dataDichiarazioniParteAS[0], 10);
    this.form.get('parteA')?.get('dichiarazioni')?.get('dataCompilazione')?.patchValue({
      "year": annoDichiarazioni,
      "month": meseDichiarazioni,
      "day": giornoDichiarazioni
    })
    //
    //
    //parte B
    this.form.get('parteB')?.patchValue(data.datiParteBS);
    this.form.get('parteB')?.get('denominazione')?.patchValue(data.datiParteBS);

    //comune denominazione
    let codComuneDenominazione = data.datiParteBS.fkComune;
    if (codComuneDenominazione != null) {
      const selectedComuneDecesso = this.assignComuni.comuni.find((comune: Comune) => comune.codComune?.trim() === codComuneDenominazione.trim());
      this.form.get('parteB')?.get('denominazione')?.get('fkComuneDescr')?.patchValue(selectedComuneDecesso?.descrComune);
    }

    this.form.get('parteB')?.get('dataMorte')?.patchValue(data.datiParteBS);
    this.form.get('parteB')?.get('firmaRecapitiUfficiale')?.patchValue(data.datiParteBS);
    this.form.get('parteB')?.get('altroComuneNascita')?.patchValue(data.datiParteBS);

    //altro comune nascita
    let codComuneNascita = data.datiParteBS.fkLocalitaComuneNascita;
    if (codComuneNascita != null) {
      const selectedComuneNascita = this.assignComuni.comuni.find((comune: Comune) => comune.codComune?.trim() === codComuneNascita.trim());
      this.form.get('parteB')?.get('altroComuneNascita')?.get('fkLocalitaComuneNascitaDescr')?.patchValue(selectedComuneNascita?.descrComune);
    }

    //altro stato nascita
    let codStatoNascita = data.datiParteBS.fkLocalitaStatoEsteroNascita;
    if (codStatoNascita != null) {
      const selectedStatoNascita = this.assignStati.stati.find((stato: Stato) => stato.codIstat === codStatoNascita);
      this.form.get('parteB')?.get('fkLocalitaStatoEsteroNascitaDescr')?.patchValue(selectedStatoNascita?.descrizione);
    }

    this.form.get('parteB')?.get('casiStatoCivile')?.patchValue(data.datiParteBS);
    //dataNascita
    const giornoNascita = parseInt(data.datiParteBS.giornoNascita, 10);
    const meseNascita = parseInt(data.datiParteBS.meseNascita, 10);
    const annoNascita = parseInt(data.datiParteBS.annoNascita, 10);
    this.form.get('parteB')?.get('dataNascita')?.patchValue({
      "year": annoNascita,
      "month": meseNascita,
      "day": giornoNascita
    })
    //
    //data Morte
    const giornoMorte = parseInt(data.datiParteBS.giornoDataMorte, 10);
    const meseMorte = parseInt(data.datiParteBS.meseDataMorte, 10);
    const annoMorte = parseInt(data.datiParteBS.annoDataMorte, 10);
    this.form.get('parteB')?.get('dataMorte')?.patchValue({
      data: {
        "year": annoMorte,
        "month": meseMorte,
        "day": giornoMorte
      }
    })
    //
    this.form.get('parteB')?.get('altroComuneResidenza')?.patchValue(data.datiParteBS);

    if (this.form.get('parteB')?.get('denominazione')?.get('fkComuneDescr')?.value != undefined) {
      const selectedComune = this.assignComuni.comuni.find((comune: Comune) => comune.descrComune?.trim() === this.form.get('parteB')?.get('denominazione')?.get('fkComuneDescr')?.value.trim());
      this.form.get('parteB')?.get('denominazione')?.get('fkComune')?.setValue(selectedComune?.codComune);
      this.form.get('parteB')?.get('denominazione')?.get('provincia')?.setValue(selectedComune?.sigla);
    }
    if (this.form.get('parteB')?.get('altroComuneNascita')?.get('fkLocalitaComuneNascitaDescr')?.value != undefined) {
      const selectedComune = this.assignComuni.comuni.find((comune: Comune) => comune.descrComune?.trim() === this.form.get('parteB')?.get('altroComuneNascita')?.get('fkLocalitaComuneNascitaDescr')?.value.trim());
      this.form.get('parteB')?.get('altroComuneNascita')?.get('fkLocalitaComuneNascita')?.setValue(selectedComune?.codComune);
      this.form.get('parteB')?.get('altroComuneNascita')?.get('provincia')?.setValue(selectedComune?.sigla);
    }
    if (this.form.get('parteB')?.get('altroComuneResidenza')?.get('fkComuneResidenzaDescr')?.value != undefined) {
      const selectedComune = this.assignComuni.comuni.find((comune: Comune) => comune.descrComune?.trim() === this.form.get('parteB')?.get('altroComuneResidenza')?.get('fkComuneResidenzaDescr')?.value.trim());
      this.form.get('parteB')?.get('altroComuneResidenza')?.get('fkComuneResidenza')?.setValue(selectedComune?.codComune);
      this.form.get('parteB')?.get('altroComuneResidenza')?.get('provincia')?.setValue(selectedComune?.sigla);
    }    

    //altro comune residenza
    let codComuneResidenza = data.datiParteBS.fkComuneResidenza;
    if (codComuneResidenza != null) {
      const selectedComuneResidenza = this.assignComuni.comuni.find((comune: Comune) => comune.codComune?.trim() === codComuneResidenza.trim());
      this.form.get('parteB')?.get('altroComuneResidenza')?.get('fkComuneResidenzaDescr')?.patchValue(selectedComuneResidenza?.descrComune);
    }
    //
    //stato estero residenza
    let codStatoResidenza = data.datiParteBS.fkStatoResidenza;
    if (codStatoResidenza != null) {
      const selectedStatoResidenza = this.assignStati.stati.find((stato: Stato) => stato.codIstat === codStatoResidenza);
      this.form.get('parteB')?.get('fkStatoResidenzaDescr')?.patchValue(selectedStatoResidenza?.descrizione);
    }
    //

    //stato estero cittadinanza
    let codCittadinanzaStatoStraniera = data.datiParteBS.fkCittadinanzaStatoStraniera;
    if (codCittadinanzaStatoStraniera != null) {
      const selectedcodCittadinanzaStatoStraniera = this.assignStati.stati.find((stato: Stato) => stato.codIstat === codCittadinanzaStatoStraniera);
      this.form.get('parteB')?.get('fkCittadinanzaStatoStranieraDesc')?.patchValue(codCittadinanzaStatoStraniera?.descrizione);
    }
    //    

  }

  clearDati() {
    this.form.get('anagraficaForm')?.reset();
    this.form.get('parteA')?.reset();
    this.form.get('parteB')?.reset();
  }

  getCampiInvalidi(formGroup: FormGroup): string[] {
    const campiInvalidi: string[] = [];
    for (const campi in formGroup.controls) {
      if (formGroup.get(campi)?.invalid) {
        campiInvalidi.push(campi);
      }
    }
    return campiInvalidi;
  }

  async save() {
    const cf = this.form.get('anagraficaForm')?.get('codiceFiscale')?.value;
    const exists = await firstValueFrom(this.api.checkCodiceFiscale(cf,this.id));
    console.log("Chiamata esistenza CF: ", exists);
    if (exists) {
      this.toastService.showError("Anagrafica non valida: Codice Fiscale è presente in archivio");
    } else
    if (this.form.get('anagraficaForm')?.status == 'VALID' && this.form.get('parteA')?.status == 'VALID' && this.form.get('parteB')?.status == 'VALID') {
      this.salvaScheda();
      this.attivaBordi = false;
      this.annulla();
      //this.loadTableData();
    }
    else {
      if (this.form.get('anagraficaForm')?.status == 'INVALID') {
        const campiInvalidi = this.getCampiInvalidi(this.form.get('anagraficaForm') as FormGroup);
        this.toastService.showError(`Anagrafica non valida: ${campiInvalidi.join(', ')}`);
        this.attivaBordi = true;
      }
      if (this.form.get('parteA')?.status == 'INVALID') {
        const campiInvalidi = this.getCampiInvalidi(this.form.get('parteA') as FormGroup);
        this.toastService.showError(`Parte A non valida: ${campiInvalidi.join(', ')}`);
        this.attivaBordi = true;
      }
      if (this.form.get('parteB')?.status == 'INVALID') {
        const campiInvalidi = this.getCampiInvalidi(this.form.get('parteB') as FormGroup);
        this.toastService.showError(`Parte B non valida: ${campiInvalidi.join(', ')}`);
        this.attivaBordi = true;
      }
    }
  }

  async eliminaScheda() {
    let id = this.route.snapshot.params['id'];
    if (id != undefined) {
      console.log("ID per eliminazione: " + id);
      this.toastService.showSuccess("Eliminazione avvenuta con successo");
      let result = await firstValueFrom(this.api.deleteAnagrafica(id)).finally(() => this.blockUI.stop());
      this.annulla();
      //this.loadTableData();
    }
    else {
      this.toastService.showError("Scheda non valida");
      this.annulla();
    }
  }


  async salvaScheda() {
    this.blockUI.start("Creazione scheda di test in corso");
    const anagrafica = this.form.get('anagraficaForm');
    const parteA = this.form.get('parteA');
    const parteB = this.form.get('parteB');
    let id = this.route.snapshot.params['id'];
    let ana = this.inserisciScheda.inserisciAnagrafica(anagrafica, parteA, parteB, id, this.modalita);
    ana.datiParteAS = this.inserisciScheda.inserisciDatiParteA(parteA, id);
    ana.datiParteBS = this.inserisciScheda.inserisciDatiParteB(parteB, id, anagrafica);
    let result = await firstValueFrom(this.api.saveOrUpdateAnagrafica(ana)).finally(() => this.blockUI.stop());
  }

}
